<partial-loading-indicator class="dex-tranche-details-w_loading-indicator">

    @if (tranche()) {
        <div class="dex-tranche-details-w_top-row" responsiveCols (click)="onClickToggleCollapsed($event)">
            <div class="dex-tranche-details-w_top-row-col1" [responsiveCol]="1">
                <div class="dex-tranche-details-w_title">
                    {{tranche().raw.name}}
                </div>
                <div class="dex-tranche-details-w_symbol">
                    <!-- Hidden as per UAT early feedback -->
                    <!--@if (isEmbedded()) {
                        <svg class="dex-tranche-details-w_symbol-toggle"
                             [class.-collapsed]="isCollapsed()"
                             (click)="onClickToggleCollapsed($event)">
                            <use xlink:href="#chevron-down"></use>
                        </svg>
                    }-->
                    <div class="dex-tranche-details-w_symbol-value"
                         [class.-clickable]="isSymbolClickable()"
                         (click)="onSymbolClick(tranche().unitDeliverable.symbol, $event)">
                        {{tranche().unitDeliverable.symbol}}
                    </div>
                </div>
                @if (isEmbedded() && isCollapsed()) {
                    <div class="dex-tranche-details-w_acts">
                        <button class="dex-tranche-details-w_acts_btn" (click)="onTradeClick(Side.BUY, $event)">
                            Purchase
                        </button>
                        <button class="dex-tranche-details-w_acts_btn" (click)="onTradeClick(Side.SELL, $event)">
                            Redeem
                        </button>
                    </div>
                }
            </div>

            <div class="dex-tranche-details-w_top-row-col2">
                <div class="dex-tranche-details-w_total-stats" [responsiveCol]="2">
                    <div class="dex-tranche-details-w_total-stats-field">
                        <label class="dex-tranche-details-w_total-stats-field-label">
                            Total Value
                        </label>
                        <div class="dex-tranche-details-w_total-stats-field-value">
                            <span [displayDecimal]="tranche().$totalValue() | bigintDeliverableDisplayDecimal:tranche().$totalValueDeliverable()"></span>
                        </div>
                    </div>
                    <div class="dex-tranche-details-w_total-stats-field">
                        <label class="dex-tranche-details-w_total-stats-field-label">
                            Total Units
                        </label>
                        <div class="dex-tranche-details-w_total-stats-field-value">
                            <span [displayDecimal]="tranche().$totalUnits() | bigintDeliverableDisplayDecimal:tranche().unitDeliverable"></span>
                        </div>
                    </div>
                </div>
                <div class="dex-tranche-details-w_unit-price-col" [responsiveCol]="1">
                    <div class="dex-tranche-details-w_unit-price-field">
                        <label class="dex-tranche-details-w_unit-price-field-label">
                            Unit Price
                        </label>
                        <div class="dex-tranche-details-w_unit-price-field-value">
                            <span [displayDecimal]="tranche().$unitPrice() | bigintDeliverableDisplayDecimal:tranche().unitPriceDeliverable"></span>
                        </div>
                    </div>
                    <div class="dex-tranche-details-w_unit-price-deltas">
                        <div class="dex-tranche-details-w_unit-price-delta-field">
                            <label class="dex-tranche-details-w_unit-price-delta-field-label">
                                7D Delta
                            </label>
                            <div class="dex-tranche-details-w_unit-price-delta-field-value">

                            </div>
                        </div>
                        <div class="dex-tranche-details-w_unit-price-delta-field">
                            <label class="dex-tranche-details-w_unit-price-delta-field-label">
                                1D Delta
                            </label>
                            <div class="dex-tranche-details-w_unit-price-delta-field-value">

                            </div>
                        </div>
                    </div>
                </div>
                @let basePos = tranche().$computedBasePosition();
                <div class="dex-tranche-details-w_yield" [responsiveCol]="1"
                     [class.-positive]="basePos?.yield.v > 0"
                     [class.-negative]="basePos?.yield.v < 0">
                    <div class="dex-tranche-details-w_yield-field">
                        <label class="dex-tranche-details-w_yield-field-label">
                            Yield
                        </label>
                        <div class="dex-tranche-details-w_yield-field-value">
                            <span [displayDecimal]="$safeNavigationMigration(basePos?.yieldPercent)" [decimalCount]="2" currency="%"></span>
                            <span class="dex-tranche-details-w_yield-field-value-i">ⓘ</span>
                        </div>
                    </div>
                    <div class="dex-tranche-details-w_yield-chart">
                        <sparkline
                            [width]="149"
                            [height]="40"
                            [strokeWidth]="1"
                            [data]="$safeNavigationMigration(tranche()?.raw) | dexTrancheSparkline | async"
                            [tick]="$safeNavigationMigration(basePos?.yieldNumber)"
                            [gradientOpacity]="0.5">
                        </sparkline>
                    </div>
                </div>
            </div>

            <div class="dex-tranche-details-w_top-row-col3" [responsiveCol]="3">
                @let trancheRefBalance = trancheRefBalance$ | async;
                <div class="dex-tranche-details-w_u-portfolio-field">
                    <label class="dex-tranche-details-w_u-portfolio-field-label">
                        Units Held
                    </label>
                    <div class="dex-tranche-details-w_u-portfolio-field-value">
                        @if (trancheRefBalance?.balanceDel) {
                            <span [displayDecimal]="trancheRefBalance.balance | bigintDeliverableDisplayDecimal:trancheRefBalance.balanceDel"></span>
                        }
                    </div>
                </div>
                <div class="dex-tranche-details-w_u-pnl-field">
                    <label class="dex-tranche-details-w_u-pnl-field-label">
                        Value Held
                    </label>
                    <div class="dex-tranche-details-w_u-pnl-field-value">
                        @if (trancheRefBalance?.refBalanceDel) {
                            <span [displayDecimal]="trancheRefBalance.refBalance | bigintDeliverableDisplayDecimal:trancheRefBalance.refBalanceDel"></span>
                        }
                    </div>
                </div>
            </div>
        </div>

        @if (!isCollapsed()) {
            <dex-tranche-actions
                [tranche]="tranche()"
                (tradeClick)="onTradeClick($event)">
            </dex-tranche-actions>
            <dex-tranche-compos class="dex-tranche-details-w_compose" [tranche]="tranche()"></dex-tranche-compos>
        }
    }

</partial-loading-indicator>
